import '@/shared/lib/disable-console-log'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './app/app'
import SLog from '@/shared/lib/SLog'
import { IS_SERVER_REAL } from './shared/config/global-config-store'

SLog.initSLog(IS_SERVER_REAL ? 'ai-canvas' : 'ai-canvas-debug')

// 全局禁用 Ctrl + 滚轮缩放浏览器窗口
document.addEventListener(
  'wheel',
  (e) => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault()
    }
  },
  { passive: false }
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
